import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';
@Injectable({
  providedIn: 'root'
})
export class CallLogDetailService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService
  ) { }

  /**
   * Description: Método que llama el servicio web que envia el detall de llamadas
   * Autor: Diego Diaz
   * @param data parámetros de entrada
   * @return N/A
   */
  sendCallLogRequest(data){
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_CALL_LOG_DETAIL_REQUEST, data);
  }

  
  /**
   * Description: Método que llama el servicio web de obtener saldo de una línea
   * Autor: Diego Diaz
   * @param phone número a consultar saldo
   * @return saldo
   */
  getBalance(phone) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_GET_BALANCE, { "subscriptionId": phone });
  }

   /**
   * Description: Método que llama el servicio web de obtener el valor de llamadas entrantes o salientes
   * Autor: Diego Diaz
   * @param N/A
   * @return valores input y putput
   */
  getInOutputValue() {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_CALL_LOG_DETAIL_GET_INPUT_OUTPUT_VALUES, "");
  }


}
